<template>
  <div class="right_">
    <!-- <div class="right_child right_1 right_2">
      微信投保
      <div class="code_"><img src="../assets/code.png" alt="code" /></div>
    </div> -->
    <!-- <div class="right_child right_1">在线客服</div> -->
    <div class="right_child" @click="goBackTop">返回顶部</div>
  </div>
</template>

<script>
export default {
  methods: {
    goBackTop() {
      document.documentElement.scrollTop = 0;
    }
  }
};
</script>

<style lang="scss" scoped>
.right_ {
  .code_ {
    display: none;
    position: absolute;
    right: 100%;
    bottom: 48%;
    img {
      width: 120px;
      height: 120px;
    }
  }
  width: 60px;
  position: fixed;
  right: 0;
  bottom: 0;
  .right_child {
    margin: 5px;
    padding: 8px;
    width: 50px;
    height: 50px;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 0px 17px 0px rgba(0, 0, 0, 0.1);
    border-radius: 3px;
    font-size: 13px;
    font-family: Microsoft YaHei UI;
    font-weight: 400;
    color: rgba(153, 153, 153, 1);
    text-align: center;
    line-height: 16px;
  }
  .right_child:hover {
    cursor: pointer;
    background: rgba(254, 143, 45, 1);
    color: #fff;
  }
  .right_2:hover .code_ {
    display: block;
  }
  .right_1 {
    color: rgba(254, 143, 45, 1);
  }
}
</style>
